<template>
  <div class="app-product-aid-footer">
    <button class="app-product-aid-footer__button" :disabled="backDisabled" @click="$emit('back')">
      <TappIcon icon="arrow-left" :size="16" />
      {{ t('marketingPages.productAid.footer.back') }}
    </button>

    <span v-if="showCounter" class="app-product-aid-footer__counter">
      {{ counter }}
    </span>

    <button class="app-product-aid-footer__button" @click="$emit('reset')">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
        />
      </svg>
      {{ t('marketingPages.productAid.footer.reset') }}
    </button>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();

  defineProps<{
    backDisabled?: boolean;
    showCounter?: boolean;
    counter?: string;
  }>();

  defineEmits<{
    back: [];
    reset: [];
  }>();
</script>

<style lang="postcss" scoped>
  .app-product-aid-footer {
    display: flex;
    justify-content: space-between;
    padding-bottom: var(--spacing-6);

    &__button {
      cursor: pointer;

      display: flex;
      gap: var(--spacing-1);
      align-items: center;

      padding: var(--spacing-1) var(--spacing-2);
      border: 0;
      border-radius: var(--spacing-1);

      font: var(--typography-small-body-sm);
      color: var(--colors-black);

      background: rgb(0 0 0 / 10%);

      &:disabled {
        cursor: not-allowed;
        opacity: 0.4;
      }

      svg {
        flex-shrink: 0;
      }
    }

    &__counter {
      padding: var(--spacing-1) var(--spacing-2);
      border-radius: var(--spacing-1);

      font: var(--typography-small-body-sm);
      color: var(--colors-black);

      background: rgb(0 0 0 / 10%);
    }
  }
</style>
